(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const applyAccordionState = () => {
      const showAccordionOnMobile =
        document.querySelector('[data-show-accordion]')?.getAttribute('data-show-accordion') === 'true';
      const isMobile = window.matchMedia('(max-width: 767px)').matches;
      document.querySelectorAll('details[data-footer-accordions]').forEach((el) => {
        if (showAccordionOnMobile && isMobile) {
          el.removeAttribute('open', '');
        } else if (!showAccordionOnMobile && isMobile) {
          // Do not show accordion on mobile if setting disallows
          el.setAttribute('open', true);
        } else if (!isMobile) {
          // On desktop, always open accordions
          el.setAttribute('open', '');
        }
      });
    };
    applyAccordionState();
    window.addEventListener('resize', applyAccordionState);
    document.addEventListener('shopify:section:load', (event) => {
      // Apply accordion state when a new section is loaded
      applyAccordionState();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-comparison"] && !Shopify.designMode) return;
  try {
    
  /*
  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout');
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) {
        // console.error('Error: No [data-drag-button] found inside <image-comparison>.');
        return;
      }

      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.addClasses.bind(this));
        btn.addEventListener('touchstart', this.addClasses.bind(this));
      });

      // document.body.addEventListener('mouseup', this.removeClasses.bind(this));
      // document.body.addEventListener('mouseleave', this.removeClasses.bind(this));
      document.body.addEventListener('touchend', this.removeClasses.bind(this));
      document.body.addEventListener('touchcancel', this.removeClasses.bind(this));

      document.body.addEventListener('mousemove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      document.body.addEventListener('touchmove', (e) => {
        if (!this.active) return;
        let x =
          this.layout === 'horizontal'
            ? e.touches[0].pageX - this.bounding.left
            : e.touches[0].pageY - (this.bounding.top + window.scrollY);
        this.movecurs(x);
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //this.animateDrag();

              observer.disconnect();
            } else {
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    animateDrag() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      let start = performance.now();
      const totalDuration = 2000;
      let currentPos = min;

      const animateRight = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          currentPos = min + (max - min) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateRight);
        } else {
          this.movecurs(max);
          setTimeout(() => {
            this.animateToMiddle();
          }, 500);
        }
      };

      requestAnimationFrame(animateRight);
    }

    animateToMiddle() {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const middle = (min + max) / 2;
      let start = performance.now();
      const totalDuration = 1000;

      const animateMiddle = (time) => {
        const progress = (time - start) / totalDuration;
        if (progress < 1) {
          const currentPos = max - (max - middle) * progress;
          this.movecurs(currentPos);
          requestAnimationFrame(animateMiddle);
        } else {
          this.movecurs(middle);
        }
      };

      requestAnimationFrame(animateMiddle);
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  */
  // Helper functions for body scroll control

  class ImageComparison extends HTMLElement {
    constructor() {
      super();
      this.active = false;

      // Bind all event handlers once
      this.boundAddClasses = this.addClasses.bind(this);
      this.boundRemoveClasses = this.removeClasses.bind(this);
      this.boundMouseMove = this.handleMouseMove.bind(this);
      this.boundTouchMove = this.handleTouchMove.bind(this);
    }

    get iconButtons() {
      return this.querySelectorAll('[data-drag-button]');
    }

    get layout() {
      return this.getAttribute('data-layout') || 'horizontal';
    }

    get bounding() {
      return this.getBoundingClientRect();
    }

    addClasses() {
      lockBodyScroll();
      this.active = true;
      this.iconButtons.forEach((btn) => btn.classList.add('animating'));

      // Add temporary event listeners
      document.addEventListener('mousemove', this.boundMouseMove);
      document.addEventListener('touchmove', this.boundTouchMove, { passive: false });
      document.addEventListener('mouseup', this.boundRemoveClasses);
      document.addEventListener('mouseleave', this.boundRemoveClasses);
      document.addEventListener('touchend', this.boundRemoveClasses);
      document.addEventListener('touchcancel', this.boundRemoveClasses);
    }

    removeClasses() {
      unlockBodyScroll();
      this.active = false;
      this.iconButtons.forEach((btn) => btn.classList.remove('animating'));

      // Clean up temporary event listeners
      document.removeEventListener('mousemove', this.boundMouseMove);
      document.removeEventListener('touchmove', this.boundTouchMove);
      document.removeEventListener('mouseup', this.boundRemoveClasses);
      document.removeEventListener('mouseleave', this.boundRemoveClasses);
      document.removeEventListener('touchend', this.boundRemoveClasses);
      document.removeEventListener('touchcancel', this.boundRemoveClasses);
    }

    handleMouseMove(e) {
      if (!this.active) return;
      const x =
        this.layout === 'horizontal' ? e.pageX - this.bounding.left : e.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    handleTouchMove(e) {
      if (!this.active) return;
      e.preventDefault(); // Prevent scrolling while dragging
      const touch = e.touches[0];
      const x =
        this.layout === 'horizontal'
          ? touch.pageX - this.bounding.left
          : touch.pageY - (this.bounding.top + window.scrollY);
      this.movecurs(x);
    }

    movecurs(x) {
      const distance = this.layout === 'horizontal' ? this.clientWidth : this.clientHeight;
      const max = distance - 20;
      const min = 20;
      const mouseX = Math.max(min, Math.min(x, max));
      const mousePercent = (mouseX * 100) / distance;

      this.iconButtons.forEach((btn) => {
        if (this.layout === 'horizontal') {
          btn.style.left = mousePercent + '%';
        } else {
          btn.style.top = mousePercent + '%';
        }
      });

      this.style.setProperty('--drag-position', mousePercent + '%');
    }

    init() {
      const iconButtons = this.iconButtons;
      if (!iconButtons.length) return;

      // Add permanent event listeners
      iconButtons.forEach((btn) => {
        btn.addEventListener('mousedown', this.boundAddClasses);
        btn.addEventListener('touchstart', this.boundAddClasses, { passive: true });
      });

      // Intersection Observer for triggering animation
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              observer.disconnect();
            }
          });
        },
        { threshold: 0.8 }
      );

      observer.observe(this);
    }

    disconnectedCallback() {
      // Clean up all event listeners when component is removed
      this.iconButtons.forEach((btn) => {
        btn.removeEventListener('mousedown', this.boundAddClasses);
        btn.removeEventListener('touchstart', this.boundAddClasses);
      });
      this.removeClasses(); // Cleans up any active listeners
    }

    connectedCallback() {
      this.init();
    }
  }

  customElements.define('image-comparison', ImageComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid"] && !Shopify.designMode) return;
  try {
    
const productGridInfos = document.querySelectorAll('[data-grid-info]');
productGridInfos.forEach((gridInfo) => {
  const priceDiv = gridInfo.querySelector('.product-price');
  if (priceDiv) {
    const priceHeight = priceDiv.offsetHeight;
    gridInfo.style.setProperty('--product-price-height', `${priceHeight}px`);
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridernav-all-products"] && !Shopify.designMode) return;
  try {
    
function initMatch(root){if(root.dataset.ready)return;root.dataset.ready='true';const bodyFont=getComputedStyle(document.body).fontFamily;root.style.setProperty('--rnc-body-font',bodyFont);const themeHeading=Array.from(document.querySelectorAll('h1,h2')).find(el=>!el.closest('.rnc-match'));root.style.setProperty('--rnc-heading-font',themeHeading?getComputedStyle(themeHeading).fontFamily:bodyFont);const q=s=>root.querySelector(s),key=k=>q('[data-key="'+k+'"]');let data=JSON.parse(q('[data-products]').textContent),products=data.items,category='All Products';const types=['All Products','Smart Displays','Auxiliary Lights','Accessories'];const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));const sidebar=q('.sidebar'),open=q('.mobilefilter'),close=q('.closefilter');function closeDrawer(){sidebar.classList.remove('open');open.setAttribute('aria-expanded','false');}open.addEventListener('click',()=>{sidebar.classList.add('open');open.setAttribute('aria-expanded','true');close.focus()});close.addEventListener('click',()=>{closeDrawer();open.focus()});root.addEventListener('keydown',e=>{if(e.key==='Escape')closeDrawer()});function render(){key('tabs').innerHTML=types.map(c=>`<button type="button" data-cat="${c}" class="${category===c?'active':''}" aria-pressed="${category===c}">${c}</button>`).join('');key('filters').innerHTML=types.map(c=>`<label><input type="radio" name="rnc-${root.id}" value="${c}" ${c===category?'checked':''}>${c}</label>`).join('');let list=products.filter(p=>(category==='All Products'||p.cat===category)&&p.name.toLowerCase().includes(key('search').value.toLowerCase()));const sort=key('sort').value;if(sort==='featured'){const rank=p=>{const n=(p.name+' '+p.handle).toLowerCase();if(p.cat==='Smart Displays'&&n.includes('r7m'))return 0;if(p.cat==='Smart Displays'&&n.includes('r7x'))return 1;if(p.cat==='Auxiliary Lights'&&n.includes('q5')&&!/cover|mount|lens|cable|controller/.test(n))return 2;return p.cat==='Smart Displays'?3:p.cat==='Auxiliary Lights'?5:4;};list.sort((a,b)=>rank(a)-rank(b));}if(sort==='az'||sort==='za')list.sort((a,b)=>a.name.localeCompare(b.name)*(sort==='az'?1:-1));if(sort==='price-asc'||sort==='price-desc')list.sort((a,b)=>(a.price-b.price)*(sort==='price-asc'?1:-1));key('count').textContent=list.length+' products';key('grid').innerHTML=list.length?list.map((p,i)=>`<article class="card"><div class="photo">${p.img?`<img src="${esc(p.img)}" alt="${esc(p.name)}" width="800" height="800" loading="${i<3?'eager':'lazy'}">`:''}</div><div class="category">${esc(p.cat)}</div><h2><a href="${esc(p.url)}">${esc(p.name)}</a></h2><p>${esc(p.desc)}</p>${root.dataset.price==='true'?`<div class="price">${p.varies?'From ':''}${p.money}</div>`:''}<a class="view" href="${esc(p.url)}">${esc(root.dataset.view)} <span>↗</span></a></article>`).join(''):'<p class="empty">No products found. Try a different search.</p>';}key('tabs').addEventListener('click',e=>{const b=e.target.closest('[data-cat]');if(b){category=b.dataset.cat;render()}});key('filters').addEventListener('change',e=>{category=e.target.value;render();closeDrawer()});q('.sidebar>button:last-child').addEventListener('click',()=>{category='All Products';key('search').value='';key('sort').value='featured';render()});key('search').addEventListener('input',render);key('sort').addEventListener('change',render);let copyTimer;function legacyCopy(code){const field=document.createElement('textarea');field.value=code;field.setAttribute('readonly','');field.style.cssText='position:fixed;top:0;left:-9999px;opacity:0';document.body.appendChild(field);field.select();field.setSelectionRange(0,code.length);let ok=false;try{ok=document.execCommand('copy')}finally{field.remove();key('copy').focus({preventScroll:true})}return ok}key('copy')?.addEventListener('click',async()=>{const button=key('copy'),status=key('copy-status');clearTimeout(copyTimer);button.disabled=true;let ok=false;try{if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(root.dataset.code);ok=true}}catch{}if(!ok){try{ok=legacyCopy(root.dataset.code)}catch{}}button.disabled=false;button.classList.toggle('is-copied',ok);button.textContent=ok?'✓ Copied':'Copy';status.textContent=ok?'':'Copy unavailable. Please select and copy the code.';if(ok)copyTimer=setTimeout(()=>{button.textContent='Copy';button.classList.remove('is-copied')},3000);});render();async function loadRest(){const status=key('status');try{let next=data.next;const seen=new Set();while(next){if(seen.has(next))throw Error('pagination');seen.add(next);status.textContent='Loading products…';const url=new URL(next,location.origin);url.searchParams.set('section_id',root.dataset.section);const res=await fetch(url);if(!res.ok)throw Error('load');const doc=new DOMParser().parseFromString(await res.text(),'text/html');const page=JSON.parse(doc.querySelector('[data-products]').textContent);const handles=new Set(products.map(p=>p.handle));products.push(...page.items.filter(p=>!handles.has(p.handle)));next=page.next;}status.textContent='';key('more').hidden=true;render()}catch{status.textContent='Some products could not load. Refresh or use Next page to continue.';}}loadRest();}document.querySelectorAll('.rnc-match').forEach(initMatch);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.rnc-match').forEach(initMatch));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridernav-copy-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rn-responsive-sale')) {
    customElements.define(
      'rn-responsive-sale',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;

          const button = this.querySelector('.rnrs__copy');
          const message = this.querySelector('.rnrs__message');

          if (!button || !message) return;

          this.initialized = true;

          button.addEventListener('click', async () => {
            const code = (this.dataset.code || '').trim();

            if (!code) return;

            let copied = false;

            try {
              if (
                navigator.clipboard &&
                window.isSecureContext
              ) {
                await navigator.clipboard.writeText(code);
                copied = true;
              }
            } catch (error) {
              copied = false;
            }

            if (!copied) {
              const textarea = document.createElement('textarea');

              textarea.value = code;
              textarea.setAttribute('readonly', '');
              textarea.style.cssText =
                'position:fixed;left:-9999px;top:0;opacity:0;font-size:16px;';

              document.body.appendChild(textarea);
              textarea.focus();
              textarea.select();
              textarea.setSelectionRange(0, code.length);

              try {
                copied = document.execCommand('copy');
              } catch (error) {
                copied = false;
              }

              textarea.remove();
              button.focus({ preventScroll: true });
            }

            message.textContent = copied
              ? 'Copied! Paste at checkout.'
              : 'Please copy manually: ' + code;
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridernav-halloween-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rn-halloween-v2')) {
  customElements.define('rn-halloween-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.timers = new Set();
      const later = (fn, ms) => { const t = setTimeout(() => { this.timers.delete(t); fn(); }, ms); this.timers.add(t); return t; };
      const copy = this.querySelector('.rnh-coupon');
      if (copy) copy.addEventListener('click', async () => {
        if (this.copying) return;
        this.copying = true;
        const code = this.dataset.code;
        let ok = false;
        try { await navigator.clipboard.writeText(code); ok = true; } catch (error) {
          const field = document.createElement('textarea');
          field.value = code; field.style.cssText = 'position:fixed;left:-9999px;top:0;font-size:16px';
          document.body.append(field); field.select(); field.setSelectionRange(0, code.length);
          try { ok = document.execCommand('copy'); } catch (fallbackError) { ok = false; }
          field.remove(); copy.focus({ preventScroll: true });
        }
        this.copying = false;
        if (!this.isConnected) return;
        copy.dataset.copied = String(ok);
        const status = this.querySelector('[data-rnh-status]');
        const error = this.querySelector('.rnh-error');
        status.textContent = ok ? this.dataset.success : this.dataset.failure;
        error.hidden = ok;
        error.textContent = ok ? '' : this.dataset.failure + ' ' + code;
        if (this.copyReset) clearTimeout(this.copyReset);
        this.copyReset = later(() => { copy.dataset.copied = 'false'; status.textContent = ''; }, 2600);
      }, { signal });
      const cards = [...this.querySelectorAll('.rnh-perk')];
      const setOpen = (card, open) => {
        card.querySelector('button').setAttribute('aria-expanded', String(open));
        card.querySelector('.rnh-perk-panel').hidden = !open;
        card.querySelector('.rnh-plus').textContent = open ? '−' : '+';
      };
      cards.forEach(card => {
        const button = card.querySelector('button');
        const open = () => { cards.forEach(c => setOpen(c, c === card)); };
        card.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { card.hovered = true; if (!card.dismissed) open(); } }, { signal });
        card.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') { card.hovered = false; card.dismissed = false; later(() => { if (!card.hovered && !card.contains(document.activeElement)) setOpen(card, false); }, 150); } }, { signal });
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-expanded') === 'true') { setOpen(card, false); card.dismissed = true; }
          else { card.dismissed = false; open(); }
        }, { signal });
        card.addEventListener('focusin', event => { if (event.target.matches(':focus-visible') && !card.dismissed) open(); }, { signal });
        card.addEventListener('focusout', event => { if (!card.contains(event.relatedTarget) && !card.hovered) { setOpen(card, false); card.dismissed = false; } }, { signal });
      });
      document.addEventListener('pointerdown', event => { if (!event.target.closest('.rnh-perk')) cards.forEach(c => setOpen(c, false)); }, { signal });
      this.addEventListener('keydown', event => { if (event.key === 'Escape') cards.forEach(c => { setOpen(c, false); c.dismissed = true; }); }, { signal });
      this.addEventListener('shopify:block:select', event => { const card = event.target.closest('.rnh-perk'); if (card) setOpen(card, true); }, { signal });
      const clock = this.querySelector('.rnh-countdown');
      if (clock) {
        const tick = () => {
          const start = Date.parse(this.dataset.start), end = Date.parse(this.dataset.end), now = Date.now();
          if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) { clock.hidden = true; return; }
          const before = now < start, ended = now >= end;
          clock.querySelector('.rnh-phase').textContent = ended ? this.dataset.ended : before ? this.dataset.before : this.dataset.live;
          const seconds = Math.max(0, Math.floor(((before ? start : end) - now) / 1000));
          const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
          for (const [unit, value] of Object.entries(values)) clock.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0');
          if (copy) copy.disabled = ended;
        };
        tick(); this.interval = setInterval(tick, 1000);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; clearInterval(this.interval); this.timers?.forEach(clearTimeout); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ridernav-manual-hub"] && !Shopify.designMode) return;
  try {
    
  const initializeRiderNavManualHub = (root) => {
    if (!root || root.dataset.rnInitialized === 'true') return;
    root.dataset.rnInitialized = 'true';

    /* ---- Page filter search ---- */
    const form = root.querySelector('.rn-manual-search');
    const input = root.querySelector('.rn-manual-search input');
    const items = [...root.querySelectorAll('.rn-manual-search-item')];
    const noResults = root.querySelector('.rn-manual-no-results');

    const normalize = (value) => value.toLowerCase().trim().replace(/[-–—/]/g, ' ');

    if (form && input && noResults) {
      const filterItems = (shouldScroll) => {
        const query = normalize(input.value);
        let count = 0;

        items.forEach((item) => {
          const haystack = normalize(`${item.dataset.search || ''} ${item.textContent}`);
          const match = !query || query.split(/\s+/).every((word) => haystack.includes(word));
          item.hidden = !match;
          if (match) count += 1;
        });

        noResults.hidden = count !== 0;
        if (query && count && shouldScroll) {
          items.find((item) => !item.hidden)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        filterItems(true);
      });
      input.addEventListener('input', () => {
        if (!input.value.trim()) filterItems(false);
      });
      input.addEventListener('search', () => filterItems(false));
    }

    /* ---- FAQ accordion ---- */
    root.querySelectorAll('.rn-manual-faq__q').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.rn-manual-faq__item');
        const panel = item.querySelector('.rn-manual-faq__a');
        const open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      });
    });

    /* ---- Sticky chip nav: smooth scroll + scrollspy ---- */
    const chips = [...root.querySelectorAll('[data-rn-chip]')];
    const map = new Map();
    chips.forEach((chip) => {
      const href = chip.getAttribute('href') || '';
      if (href.startsWith('#')) {
        const target = document.getElementById(href.slice(1));
        if (target) map.set(target, chip);
      }
    });

    chips.forEach((chip) => {
      chip.addEventListener('click', (event) => {
        const href = chip.getAttribute('href') || '';
        if (href.startsWith('#')) {
          const target = document.getElementById(href.slice(1));
          if (target) {
            event.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      });
    });

    if (map.size && 'IntersectionObserver' in window) {
      const spy = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            chips.forEach((c) => c.classList.remove('is-active'));
            const chip = map.get(entry.target);
            if (chip) chip.classList.add('is-active');
          }
        });
      }, { rootMargin: '-25% 0px -65% 0px' });
      map.forEach((_, target) => spy.observe(target));
    }

    /* ---- Scroll reveal (armed only when JS runs, skipped for reduced motion) ---- */
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion && 'IntersectionObserver' in window) {
      const animated = [...root.querySelectorAll('.rn-anim')];
      if (animated.length) {
        root.setAttribute('data-anim-ready', '');
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.1 });
        animated.forEach((el) => io.observe(el));
      }
    }
  };

  document.querySelectorAll('[data-rn-manual-hub]').forEach(initializeRiderNavManualHub);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-rn-manual-hub]').forEach(initializeRiderNavManualHub);
  });

  } catch(e) { console.error(e); }
})();
})();
